// Forms are created using React-Hook-Form (https://react-hook-form.com/)
/* eslint-disable camelcase */
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import { createRandomId } from '../../../../util/createRandomId';

import { StyledFormWrapper, StyledDetailText } from '../FormsStyles';

const AbuseForm = card => {
  const {
    modal_form_1,
    modal_details_title_1,
    modal_details_text_1,
    modal_form_2,
    modal_details_title_2,
    modal_details_text_2,
    modal_form_3,
    modal_details_title_3,
    modal_details_text_3,
    modal_form_4,
    modal_details_title_4,
    modal_details_text_4,
    modal_form_5,
    modal_details_title_5,
    modal_details_text_5,
    modal_form_6,
    modal_details_title_6,
    modal_details_text_6,
    modal_form_7,
    modal_details_title_7,
    modal_details_text_7,
    modal_form_8,
    modal_details_title_8,
    modal_details_text_8,
    modal_form_9,
    modal_details_title_9,
    modal_details_text_9,
    modal_form_10,
    modal_details_title_10,
    modal_details_text_10,
    modal_form_11,
    modal_details_title_11,
    modal_details_text_11,
  } = card;

  const { register, handleSubmit, errors } = useForm();

  const [modalSideTitle, setModalSideTitle] = useState(modal_details_title_1[0].text);
  const [modalSideText, setModalSideText] = useState(modal_details_text_1[0].text);
  const [availableFormFields, setAvailableFormFields] = useState([]);
  const [showAbuseForm, setShowAbuseForm] = useState('is-hidden');
  const [showThankYou, setShowThankYou] = useState('is-hidden');
  const [showHideParentForm, setShowHideParentForm] = useState('is-block');
  const [formResponseError, setFormResponseError] = useState('error-text');
  const encodeFormData = data => {
    const returnFromData = data.form[0].fields
      .map(item => `&abuse_report[${item.name}]=${encodeURIComponent(item.val)}`)
      .reduce((acc, val) => acc + val)
      .concat(`&abuse_report[abuse_type]=${data.form[0].abuse_type}`);

    return returnFromData;
  };

  const onSubmit = data => {
    let urlEncodeFormData;
    let setFormData;

    const abuseType = data.abuse_type;

    switch (abuseType) {
      case 'dmca':
        urlEncodeFormData = {
          form: [
            {
              abuse_type: 'dmca',
              fields: [
                {
                  name: 'reporter_name',
                  val: data.reporter_name,
                },
                {
                  name: 'email',
                  val: data.email,
                },
                {
                  name: 'copyright_holder_name',
                  val: data.copyright_holder_name,
                },
                {
                  name: 'address',
                  val: data.address,
                },
                {
                  name: 'phone',
                  val: data.phone,
                },
                {
                  name: 'infringing_description',
                  val: data.infringing_description,
                },
                {
                  name: 'original_description',
                  val: data.original_description,
                },
                {
                  name: 'digital_signature',
                  val: data.digital_signature,
                },
                {
                  name: 'acknowledgment_check',
                  val: 'acknowledged',
                },
              ],
            },
          ],
        };
        setFormData = encodeFormData(urlEncodeFormData);
        break;
      case 'trademark':
        urlEncodeFormData = {
          form: [
            {
              abuse_type: 'trademark',
              fields: [
                {
                  name: 'reporter_name',
                  val: data.reporter_name,
                },
                {
                  name: 'email',
                  val: data.email,
                },
                {
                  name: 'address',
                  val: data.address,
                },
                {
                  name: 'phone',
                  val: data.phone,
                },
                {
                  name: 'trademarked_work',
                  val: data.trademarked_work,
                },
                {
                  name: 'registration_office',
                  val: data.registration_office,
                },
                {
                  name: 'registration_number',
                  val: data.registration_number,
                },
                {
                  name: 'abuse_comments',
                  val: data.abuse_comments,
                },
                {
                  name: 'infringing_description',
                  val: data.infringing_description,
                },
                {
                  name: 'digital_signature',
                  val: data.digital_signature,
                },
              ],
            },
          ],
        };
        setFormData = encodeFormData(urlEncodeFormData);
        break;
      case 'spam':
        urlEncodeFormData = {
          form: [
            {
              abuse_type: 'spam',
              fields: [
                {
                  name: 'reporter_name',
                  val: data.reporter_name,
                },
                {
                  name: 'email',
                  val: data.email,
                },
                {
                  name: 'headers',
                  val: data.headers,
                },
                {
                  name: 'message_body',
                  val: data.message_body,
                },
                {
                  name: 'spamvertisement_body',
                  val: data.spamvertisement_body,
                },
              ],
            },
          ],
        };
        setFormData = encodeFormData(urlEncodeFormData);
        break;
      case 'phishing':
        urlEncodeFormData = {
          form: [
            {
              abuse_type: 'phishing',
              fields: [
                {
                  name: 'reporter_name',
                  val: data.reporter_name,
                },
                {
                  name: 'email',
                  val: data.email,
                },
                {
                  name: 'phishing_target',
                  val: data.phishing_target,
                },
                {
                  name: 'evidence_urls',
                  val: data.evidence_urls,
                },
                {
                  name: 'additional_information',
                  val: data.additional_information,
                },
              ],
            },
          ],
        };
        setFormData = encodeFormData(urlEncodeFormData);
        break;
      case 'malware':
        urlEncodeFormData = {
          form: [
            {
              abuse_type: 'malware',
              fields: [
                {
                  name: 'reporter_name',
                  val: data.reporter_name,
                },
                {
                  name: 'email',
                  val: data.email,
                },
                {
                  name: 'evidence_urls',
                  val: data.evidence_urls,
                },
                {
                  name: 'additional_information',
                  val: data.additional_information,
                },
              ],
            },
          ],
        };
        setFormData = encodeFormData(urlEncodeFormData);
        break;
      case 'botnet':
        urlEncodeFormData = {
          form: [
            {
              abuse_type: 'botnet',
              fields: [
                {
                  name: 'reporter_name',
                  val: data.reporter_name,
                },
                {
                  name: 'email',
                  val: data.email,
                },
                {
                  name: 'evidence_urls',
                  val: data.evidence_urls,
                },
              ],
            },
          ],
        };
        setFormData = encodeFormData(urlEncodeFormData);
        break;
      case 'intrusion':
        urlEncodeFormData = {
          form: [
            {
              abuse_type: 'intrusion',
              fields: [
                {
                  name: 'reporter_name',
                  val: data.reporter_name,
                },
                {
                  name: 'email',
                  val: data.email,
                },
                {
                  name: 'evidence',
                  val: data.evidence,
                },
                {
                  name: 'timezone',
                  val: data.timezone,
                },
              ],
            },
          ],
        };
        setFormData = encodeFormData(urlEncodeFormData);
        break;
      case 'childabuse':
        urlEncodeFormData = {
          form: [
            {
              abuse_type: 'childabuse',
              fields: [
                {
                  name: 'reporter_name',
                  val: data.reporter_name,
                },
                {
                  name: 'email',
                  val: data.email,
                },
                {
                  name: 'evidence_urls',
                  val: data.evidence_urls,
                },
                {
                  name: 'digital_signature',
                  val: data.digital_signature,
                },
              ],
            },
          ],
        };
        setFormData = encodeFormData(urlEncodeFormData);
        break;
      case 'violent':
        urlEncodeFormData = {
          form: [
            {
              abuse_type: 'violent',
              fields: [
                {
                  name: 'reporter_name',
                  val: data.reporter_name,
                },
                {
                  name: 'email',
                  val: data.email,
                },
                {
                  name: 'evidence_urls',
                  val: data.evidence_urls,
                },
                {
                  name: 'additional_information',
                  val: data.additional_information,
                },
              ],
            },
          ],
        };
        setFormData = encodeFormData(urlEncodeFormData);
        break;
      case 'other':
        urlEncodeFormData = {
          form: [
            {
              abuse_type: 'other',
              fields: [
                {
                  name: 'reporter_name',
                  val: data.reporter_name,
                },
                {
                  name: 'email',
                  val: data.email,
                },
                {
                  name: 'original_description',
                  val: data.original_description,
                },
                {
                  name: 'evidence',
                  val: data.evidence,
                },
                {
                  name: 'abuse_comments',
                  val: data.abuse_comments,
                },
              ],
            },
          ],
        };
        setFormData = encodeFormData(urlEncodeFormData);
        break;
      default:
        urlEncodeFormData = '';
    }

    fetch('https://inbound.digitalocean.com/contact_forms/abuse_reports', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: setFormData,
    })
      .then(response => {
        if (response.status === 201) {
          setShowHideParentForm('is-hidden');
          setShowThankYou('thank-you is-block');
        } else {
          setFormResponseError('error-text is-block');
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  const onChange = event => {
    const lowerValue = event.target.value.replace(/\s+/g, '-').toLowerCase();

    setShowAbuseForm('is-block');

    switch (lowerValue) {
      case 'dmca-takedown':
        setModalSideTitle(modal_details_title_2[0].text);
        setModalSideText(modal_details_text_2[0].text);

        availableFormFields.length = 0;
        setAvailableFormFields(
          availableFormFields.concat(
            {
              form_type: 'input',
              type: 'text',
              id: 'DmcaAbuse-copyrightHolderName',
              name: 'copyright_holder_name',
              required: true,
              placeholder: 'Copyright Owners Full Name',
              errorMessage: 'Copyright Owners Full Name',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'DmcaAbuse-reporterName',
              name: 'reporter_name',
              required: true,
              placeholder: 'Your Full Name',
              errorMessage: 'Full name is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'DmcaAbuse-address',
              name: 'address',
              required: true,
              placeholder: 'Address',
              errorMessage: 'Address is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'DmcaAbuse-phone',
              name: 'phone',
              required: true,
              placeholder: 'Phone Number (Digits Only)',
              errorMessage: 'Phone number is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'DmcaAbuse-email',
              name: 'email',
              required: true,
              placeholder: 'Email Address',
              errorMessage: 'Email address is required',
            },
            {
              form_type: 'textarea',
              id: 'DmcaAbuse-infringingDescription',
              name: 'infringing_description',
              required: true,
              placeholder: 'URL(s) and/or a description of the infringing content',
              errorMessage: 'Infringing content is required',
            },
            {
              form_type: 'textarea',
              id: 'DmcaAbuse-originalDescription',
              name: 'original_description',
              required: true,
              placeholder: 'URL(s) and/or a description of the original content',
              errorMessage: 'Original content is required',
            },
            {
              form_type: 'checkbox',
              id: 'DmcaAbuse-acknowledgementCheck',
              name: 'acknowledgment_check',
              required: true,
              placeholder:
                'By checking this box, you attest, under penalty of perjury, that (1) you have a good faith belief that use of the material in this report is not authorized by the copyright owner, its agent, or the law; (2) you are the copyright owner or authorized to act on behalf of the copyright owner; and (3) you understand, under 17 U.S.C. § 512(f), that you may be liable for any damages, including costs and attorneys fees, if you knowingly materially misrepresent that the material you are reporting is infringing.',
              errorMessage: 'Acknowledgement checkbox is required.',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'DmcaAbuse-digitalSignature',
              name: 'digital_signature',
              required: true,
              placeholder: 'Digital Signature',
              errorMessage: 'Digital Signature is required',
            },
            {
              form_type: 'hidden',
              type: 'hidden',
              name: 'abuse_type',
              set_value: 'dmca',
            },
          ),
        );

        break;
      case 'trademark-infringement':
        setModalSideTitle(modal_details_title_3[0].text);
        setModalSideText(modal_details_text_3[0].text);

        availableFormFields.length = 0;
        setAvailableFormFields(
          availableFormFields.concat(
            {
              form_type: 'input',
              type: 'text',
              id: 'TrademarkAbuse-reporterName',
              name: 'reporter_name',
              required: true,
              placeholder: 'Your Full Name',
              errorMessage: 'Full name is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'TrademarkAbuse-address',
              name: 'address',
              required: true,
              placeholder: 'Address',
              errorMessage: 'Address is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'TrademarkAbuse-phone',
              name: 'phone',
              required: true,
              placeholder: 'Phone Number (Digits Only)',
              errorMessage: 'Phone number is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'TrademarkAbuse-email',
              name: 'email',
              required: true,
              placeholder: 'Email Address',
              errorMessage: 'Email address is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'TrademarkAbuse-trademarkedWork',
              name: 'trademarked_work',
              required: true,
              placeholder: 'Trademarked word/symbol',
              errorMessage: 'Trademarked word/symbol is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'TrademarkAbuse-registrationOffice',
              name: 'registration_office',
              required: true,
              placeholder: 'Registration office, Country',
              errorMessage: 'Registration office is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'TrademarkAbuse-registrationNumber',
              name: 'registration_number',
              required: true,
              placeholder: 'Registration number',
              errorMessage: 'Registration number is required',
            },
            {
              form_type: 'textarea',
              id: 'TrademarkAbuse-infringingDescription',
              name: 'infringing_description',
              required: true,
              placeholder: 'URL(s) and/or a description of the infringing content',
              errorMessage: 'Infringing content is required',
            },
            {
              form_type: 'textarea',
              id: 'TrademarkAbuse-abuseComments',
              name: 'abuse_comments',
              required: true,
              placeholder: 'Comments/Commercial Nexus',
              errorMessage: 'Comments field is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'TrademarkAbuse-digitalSignature',
              name: 'digital_signature',
              required: true,
              placeholder: 'Digital Signature',
              errorMessage: 'Digital Signature is required',
            },
            {
              form_type: 'hidden',
              type: 'hidden',
              name: 'abuse_type',
              set_value: 'trademark',
            },
          ),
        );
        break;
      case 'spam':
        setModalSideTitle(modal_details_title_4[0].text);
        setModalSideText(modal_details_text_4[0].text);

        availableFormFields.length = 0;
        setAvailableFormFields(
          availableFormFields.concat(
            {
              form_type: 'input',
              type: 'text',
              id: 'SpamAbuse-reporterName',
              name: 'reporter_name',
              required: true,
              placeholder: 'Your Full Name',
              errorMessage: 'Full name is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'SpamAbuse-email',
              name: 'email',
              required: true,
              placeholder: 'Email Address',
              errorMessage: 'Email address is required',
            },
            {
              form_type: 'textarea',
              id: 'SpamAbuse-headers',
              name: 'headers',
              required: true,
              placeholder: 'Headers from email received',
              errorMessage: 'Headers from email received are required',
            },
            {
              form_type: 'textarea',
              id: 'SpamAbuse-originalDescription',
              name: 'message_body',
              required: true,
              placeholder: 'Message Body',
              errorMessage: 'Message body is required',
            },
            {
              form_type: 'textarea',
              id: 'SpamAbuse-spamvertisementBody',
              name: 'spamvertisement_body',
              required: true,
              placeholder: 'Spamvertisement URLs',
              errorMessage: 'Spamvertisement URLs are required',
            },
            {
              form_type: 'hidden',
              type: 'hidden',
              name: 'abuse_type',
              set_value: 'spam',
            },
          ),
        );
        break;
      case 'phishing':
        setModalSideTitle(modal_details_title_5[0].text);
        setModalSideText(modal_details_text_5[0].text);

        availableFormFields.length = 0;
        setAvailableFormFields(
          availableFormFields.concat(
            {
              form_type: 'input',
              type: 'text',
              id: 'PhishingAbuse-reporterName',
              name: 'reporter_name',
              required: true,
              placeholder: 'Your Full Name',
              errorMessage: 'Full name is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'PhishingAbuse-email',
              name: 'email',
              required: true,
              placeholder: 'Email Address',
              errorMessage: 'Your email address is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'PhishingAbuse-target',
              name: 'phishing_target',
              required: true,
              placeholder: 'Target of Phishing Campaign',
              errorMessage: 'Target of phishing campaign is required',
            },
            {
              form_type: 'textarea',
              id: 'PhishingAbuse-evidenceURLS',
              name: 'evidence_urls',
              required: true,
              placeholder: 'Evidence URLs',
              errorMessage: 'Evidence URLs are required',
            },
            {
              form_type: 'textarea',
              id: 'PhishingAbuse-additional',
              name: 'additional_information',
              required: true,
              placeholder: 'Additional Evidence or Logs',
              errorMessage: 'Additional Evidence or Logs are required',
            },
            {
              form_type: 'hidden',
              type: 'hidden',
              name: 'abuse_type',
              set_value: 'phishing',
            },
          ),
        );
        break;
      case 'malware':
        setModalSideTitle(modal_details_title_6[0].text);
        setModalSideText(modal_details_text_6[0].text);

        availableFormFields.length = 0;
        setAvailableFormFields(
          availableFormFields.concat(
            {
              form_type: 'input',
              type: 'text',
              id: 'MalwareAbuse-reporterName',
              name: 'reporter_name',
              required: true,
              placeholder: 'Your Full Name',
              errorMessage: 'Full name is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'MalwareAbuse-email',
              name: 'email',
              required: true,
              placeholder: 'Email Address',
              errorMessage: 'Email address is required',
            },
            {
              form_type: 'textarea',
              id: 'MalwareAbuse-evidenceURLS',
              name: 'evidence_urls',
              required: true,
              placeholder: 'Evidence URLs',
              errorMessage: 'Evidence URLs are required',
            },
            {
              form_type: 'textarea',
              id: 'MalwareAbuse-additional',
              name: 'additional_information',
              required: true,
              placeholder: 'Additional Evidence or Logs',
              errorMessage: 'Additional Evidence or Logs are required',
            },
            {
              form_type: 'hidden',
              type: 'hidden',
              name: 'abuse_type',
              set_value: 'malware',
            },
          ),
        );
        break;
      case 'botnet':
        setModalSideTitle(modal_details_title_7[0].text);
        setModalSideText(modal_details_text_7[0].text);

        availableFormFields.length = 0;
        setAvailableFormFields(
          availableFormFields.concat(
            {
              form_type: 'input',
              type: 'text',
              id: 'BotnetAbuse-reporterName',
              name: 'reporter_name',
              required: true,
              placeholder: 'Your Full Name',
              errorMessage: 'Full name is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'BotnetAbuse-email',
              name: 'email',
              required: true,
              placeholder: 'Email Address',
              errorMessage: 'Email address is required',
            },
            {
              form_type: 'textarea',
              id: 'BotnetAbuse-evidence',
              name: 'evidence_urls',
              required: true,
              placeholder: 'Evidence URLs',
              errorMessage: 'Evidence URLs are required',
            },
            {
              form_type: 'hidden',
              type: 'hidden',
              name: 'abuse_type',
              set_value: 'botnet',
            },
          ),
        );
        break;
      case 'intrusion/exploit-attempts-(bruteforce,-scans-etc)':
        setModalSideTitle(modal_details_title_8[0].text);
        setModalSideText(modal_details_text_8[0].text);

        availableFormFields.length = 0;
        setAvailableFormFields(
          availableFormFields.concat(
            {
              form_type: 'input',
              type: 'text',
              id: 'BruteforceAbuse-reporterName',
              name: 'reporter_name',
              required: true,
              placeholder: 'Your Full Name',
              errorMessage: 'Full name is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'BruteforceAbuse-email',
              name: 'email',
              required: true,
              placeholder: 'Email Address',
              errorMessage: 'Email address is required',
            },
            {
              form_type: 'textarea',
              id: 'BruteforceAbuse-evidence',
              name: 'evidence',
              required: true,
              placeholder:
                'Evidence or logs of the activity showing source IP. Example:- Feb 13 22:41:11 username sshd[20654]: Received disconnect from 1.1.1.1 port 35070:11: Normal Shutdown',
              errorMessage: 'Evidence or logs of the activity showing source IP is required',
            },
            {
              form_type: 'textarea',
              id: 'BruteforceAbuse-timezone',
              name: 'timezone',
              required: true,
              placeholder: 'Your servers time zone',
              errorMessage: 'Your servers time zone is required',
            },
            {
              form_type: 'hidden',
              type: 'hidden',
              name: 'abuse_type',
              set_value: 'intrusion',
            },
          ),
        );
        break;
      case 'child-abuse':
        setModalSideTitle(modal_details_title_9[0].text);
        setModalSideText(modal_details_text_9[0].text);

        availableFormFields.length = 0;
        setAvailableFormFields(
          availableFormFields.concat(
            {
              form_type: 'input',
              type: 'text',
              id: 'ChildabuseAbuse-reporterName',
              name: 'reporter_name',
              required: true,
              placeholder: 'Your Full Name',
              errorMessage: 'Full name is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'ChildabuseAbuse-email',
              name: 'email',
              required: true,
              placeholder: 'Email Address',
              errorMessage: 'Email address is required',
            },
            {
              form_type: 'textarea',
              id: 'ChildabuseAbuse-evidence',
              name: 'evidence_urls',
              required: true,
              placeholder: 'Evidence URLs',
              errorMessage: 'Evidence URLs are required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'ChildabuseAbuse-digitalSignature',
              name: 'digital_signature',
              required: true,
              placeholder: 'Digital Signature',
              errorMessage: 'Digital Signature is required',
            },
            {
              form_type: 'hidden',
              type: 'hidden',
              name: 'abuse_type',
              set_value: 'childabuse',
            },
          ),
        );
        break;
      case 'violent-threats-and-harassment':
        setModalSideTitle(modal_details_title_10[0].text);
        setModalSideText(modal_details_text_10[0].text);

        availableFormFields.length = 0;
        setAvailableFormFields(
          availableFormFields.concat(
            {
              form_type: 'input',
              type: 'text',
              id: 'ViolentAbuse-reporterName',
              name: 'reporter_name',
              required: true,
              placeholder: 'Your Full Name',
              errorMessage: 'Full name is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'ViolentAbuse-email',
              name: 'email',
              required: true,
              placeholder: 'Email Address',
              errorMessage: 'Email address is required',
            },
            {
              form_type: 'textarea',
              id: 'ViolentAbuse-evidence',
              name: 'evidence_urls',
              required: true,
              placeholder: 'Evidence URLs',
              errorMessage: 'Evidence URLs are required',
            },
            {
              form_type: 'textarea',
              id: 'ViolentAbuse-additionalinfo',
              name: 'additional_information',
              required: true,
              placeholder: 'Additional information',
              errorMessage: 'Additional information is required',
            },
            {
              form_type: 'hidden',
              type: 'hidden',
              name: 'abuse_type',
              set_value: 'violent',
            },
          ),
        );
        break;
      case 'other':
        setModalSideTitle(modal_details_title_11[0].text);
        setModalSideText(modal_details_text_11[0].text);

        availableFormFields.length = 0;
        setAvailableFormFields(
          availableFormFields.concat(
            {
              form_type: 'input',
              type: 'text',
              id: 'OtherAbuse-reporterName',
              name: 'reporter_name',
              required: true,
              placeholder: 'Your Full Name',
              errorMessage: 'Full name is required',
            },
            {
              form_type: 'input',
              type: 'text',
              id: 'OtherAbuse-email',
              name: 'email',
              required: true,
              placeholder: 'Email Address',
              errorMessage: 'Email address is required',
            },
            {
              form_type: 'textarea',
              id: 'OtherAbuse-description',
              name: 'original_description',
              required: true,
              placeholder: 'Description of issue',
              errorMessage: 'Description of issue is required',
            },
            {
              form_type: 'textarea',
              id: 'OtherAbuse-evidence',
              name: 'evidence',
              required: true,
              placeholder: 'Evidence URL',
              errorMessage: 'Evidence URL is required',
            },
            {
              form_type: 'textarea',
              id: 'OtherAbuse-comments',
              name: 'abuse_comments',
              required: true,
              placeholder: 'Comments',
              errorMessage: 'Comments required',
            },
            {
              form_type: 'hidden',
              type: 'hidden',
              name: 'abuse_type',
              set_value: 'other',
            },
          ),
        );
        break;
      case 'select-abuse-type':
        setModalSideTitle(modal_details_title_1[0].text);
        setModalSideText(modal_details_text_1[0].text);
        setShowAbuseForm('is-hidden');
        break;
      default:
        setModalSideTitle(modal_details_title_1[0].text);
        setModalSideText(modal_details_text_1[0].text);
    }
  };

  return (
    <StyledFormWrapper>
      <p className={formResponseError}>There was a problem with your form request. Please try again.</p>
      <span className={showThankYou}>
        <h4>Thank you! Someone from our team will followup with you shortly.</h4>
      </span>

      <form name="Abuse" onSubmit={handleSubmit(onSubmit)} className={showHideParentForm}>
        <span className="form-item">
          <select id="Abuse-type" name="abuseType" ref={register} onChange={onChange}>
            {modal_form_1 ? <option value={modal_form_1}>{modal_form_1}</option> : null}
            {modal_form_2 ? <option value={modal_form_2}>{modal_form_2}</option> : null}
            {modal_form_3 ? <option value={modal_form_3}>{modal_form_3}</option> : null}
            {modal_form_4 ? <option value={modal_form_4}>{modal_form_4}</option> : null}
            {modal_form_5 ? <option value={modal_form_5}>{modal_form_5}</option> : null}
            {modal_form_6 ? <option value={modal_form_6}>{modal_form_6}</option> : null}
            {modal_form_7 ? <option value={modal_form_7}>{modal_form_7}</option> : null}
            {modal_form_8 ? <option value={modal_form_8}>{modal_form_8}</option> : null}
            {modal_form_9 ? <option value={modal_form_9}>{modal_form_9}</option> : null}
            {modal_form_10 ? <option value={modal_form_10}>{modal_form_10}</option> : null}
            {modal_form_11 ? <option value={modal_form_11}>{modal_form_11}</option> : null}
          </select>
        </span>

        <span className={showAbuseForm}>
          {availableFormFields.map(form => (
            <div>
              {form.form_type === 'input' ? (
                <span className="form-item is-required input" key={createRandomId()}>
                  <input
                    type={form.type}
                    id={form.id}
                    name={form.name}
                    placeholder={form.placeholder}
                    className={errors[form.name] ? 'error-border' : 'error-none'}
                    ref={register({ required: true })}
                  />
                  {errors[form.name] && <span className="error-text">{form.errorMessage}</span>}
                </span>
              ) : null}
              {form.form_type === 'textarea' ? (
                <span className="form-item is-required textarea" key={createRandomId()}>
                  <textarea
                    id={form.id}
                    name={form.name}
                    ref={register({
                      required: true,
                    })}
                    placeholder={form.placeholder}
                    className={errors[form.name] ? 'error-border' : 'error-none'}
                  />
                  {errors[form.name] && <span className="error-text">{form.errorMessage}</span>}
                </span>
              ) : null}

              {form.form_type === 'checkbox' ? (
                <span className="form-item is-required" key={createRandomId()}>
                  <span className="checkbox-wrapper">
                    <span className="checkbox">
                      <input
                        id={form.id}
                        type="checkbox"
                        name={form.name}
                        ref={register({
                          required: true,
                        })}
                      />
                    </span>
                    <span className="checkbox-text">{form.placeholder}</span>
                    {errors[form.name] && <span className="error-text">{form.errorMessage}</span>}
                  </span>
                </span>
              ) : null}

              {form.form_type === 'hidden' ? (
                <span key={createRandomId()}>
                  <input type="hidden" name={form.name} value={form.set_value} ref={register({ required: false })} />
                </span>
              ) : null}
            </div>
          ))}
          <p>
            By entering your name, you affirm all information is true and accurate. All information submitted to us may
            be relayed to the customer during our remediation process.
          </p>
          <span className="form-item">
            <input type="submit" value="Report Abuse" />
          </span>
        </span>
      </form>
      <StyledDetailText className={showHideParentForm}>
        <p>{modalSideTitle}</p>
        <p>{modalSideText}</p>
      </StyledDetailText>
    </StyledFormWrapper>
  );
};

export default AbuseForm;
